import {
    getStudentResultByMeasureYearGradePeriod,
    isStatusCompleted,
} from '../../utils/shared/filterUtils';
import {
    getCutscoresObjectFromThresholds,
    getThresholdsByMeasureGradePeriod,
} from '../../utils/shared/interpReducerHelpers';

export const getAvailableMeasures = (studentStatuses, availableMeasuresHC) =>
    availableMeasuresHC.filter(measure =>
        isStatusCompleted(getStudentResultByMeasureYearGradePeriod(studentStatuses, measure.key)),
    );

export const getAvailableStatuses = (
    studentStatuses,
    availableMeasures,
    interpretations,
    overallName,
    measuresKeys,
    measureMapper = () => {},
) => {
    let measures = [];
    availableMeasures.forEach(measure => {
        measures = [...measures, ...(measure.key === overallName ? measuresKeys : [measure.key])];
    });

    return studentStatuses
        .filter(status => isStatusCompleted(status) && measures.includes(status.measure))
        .sort(
            (firstStatus, secondStatus) =>
                measuresKeys.indexOf(firstStatus.measure) -
                measuresKeys.indexOf(secondStatus.measure),
        )
        .map(status => ({
            status,
            interp: getCutscoresObjectFromThresholds(
                getThresholdsByMeasureGradePeriod(
                    interpretations,
                    status.measure,
                    status.grade,
                    status.period,
                ),
                measureMapper(status.measure),
            ),
        }));
};
